import React, { createContext, useContext, useState, ReactNode } from 'react';

interface ScraperStatus {
  isRunning: boolean;
  processedCount: number;
  totalCount: number;
}

interface ScraperContextType {
  scraperStatus: ScraperStatus;
  isScraperHidden: boolean;
  setScraperStatus: (status: ScraperStatus) => void;
  setIsScraperHidden: (hidden: boolean) => void;
  handleScraperStatusUpdate: (status: ScraperStatus) => void;
  handleHideModal: () => void;
  handleReopenModal: () => void;
}

const ScraperContext = createContext<ScraperContextType | undefined>(undefined);

export const useScraperContext = () => {
  const context = useContext(ScraperContext);
  if (context === undefined) {
    throw new Error('useScraperContext must be used within a ScraperProvider');
  }
  return context;
};

interface ScraperProviderProps {
  children: ReactNode;
}

export const ScraperProvider: React.FC<ScraperProviderProps> = ({ children }) => {
  const [scraperStatus, setScraperStatus] = useState<ScraperStatus>({
    isRunning: false,
    processedCount: 0,
    totalCount: 0,
  });
  const [isScraperHidden, setIsScraperHidden] = useState(false);

  const handleScraperStatusUpdate = (status: ScraperStatus) => {
    console.log('🔍 ScraperContext: handleScraperStatusUpdate called with:', status);
    console.log('🔍 ScraperContext: Previous scraperStatus:', scraperStatus);
    setScraperStatus(status);
    console.log('🔍 ScraperContext: setScraperStatus called with:', status);
  };

  const handleHideModal = () => {
    console.log('🔍 ScraperContext: handleHideModal called');
    console.log('🔍 ScraperContext: isScraperHidden before:', isScraperHidden);
    console.log('🔍 ScraperContext: scraperStatus:', scraperStatus);
    setIsScraperHidden(true);
    console.log('🔍 ScraperContext: setIsScraperHidden(true) called');
  };

  const handleReopenModal = () => {
    setIsScraperHidden(false);
  };

  const value: ScraperContextType = {
    scraperStatus,
    isScraperHidden,
    setScraperStatus,
    setIsScraperHidden,
    handleScraperStatusUpdate,
    handleHideModal,
    handleReopenModal,
  };

  return (
    <ScraperContext.Provider value={value}>
      {children}
    </ScraperContext.Provider>
  );
};